import { createFileRoute } from '@tanstack/react-router';
import { RoleSelectionPage } from '../components/auth/RoleSelectionPage';

export const Route = createFileRoute('/role-selection')({
  component: RoleSelection,
});

function RoleSelection() {
  return <RoleSelectionPage />;
}
